import {useContext, useEffect} from 'react'
import {SectionSearchBarContext} from './SearchBar'
import {Link} from 'react-router-dom'
import {getInitials} from 'utility/utility'
import feathers from 'utility/client'
import {connectService} from 'components/service/connectService'
import {useConfirm} from 'hooks/useConfirm'
import {useNotification} from 'hooks/useNotification'

export const Administrators = connectService(
  props => {
    const confirm = useConfirm()
    const notify = useNotification()

    const {skip, total, limit, list, loading, Loader, Placeholder, Paginator, rehydrate} = props
    const {setPlaceholder} = useContext(SectionSearchBarContext)

    useEffect(() => {
      setPlaceholder(`Showing ${skip + 1} to ${skip + limit} of ${total}`)
    }, [limit, setPlaceholder, skip, total])

    const onRevokeAccess = async user => {
      const username = `${user.firstName} ${user.lastName}`
      await feathers
        .service('user')
        .remove(user._id)
        .then(data => {
          notify({
            notification: `${username} has been removed`,
            variant: 'success'
          })
        })
        .catch(e => {
          console.log(e)
          notify({
            notification: `${username} could not be removed, Please try again!`,
            variant: 'danger'
          })
        })
      rehydrate()
    }

    return (
      <div className="table-responsive">
        <table className="vw-table vw-tab-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {list.length ? (
              list.map(item => (
                <tr key={item._id} className="data-list">
                  <td>
                    <Link className="no-link-btn">
                      <div className="vw-table__name">
                        <div className="vw-table__name__no-img vw-icon-bg">
                          {getInitials(`${item.firstName} ${item.lastName}`)}
                        </div>{' '}
                        {`${item.firstName} ${item.lastName}`}
                      </div>
                    </Link>
                  </td>
                  <td>{item.email}</td>
                  <td className="text-right">
                    <button
                      className="btn btn-danger"
                      onClick={() =>
                        confirm({
                          title: `Remove administrative access?`,
                          message: `Are you sure you want to remove admin access from ${item.firstName} ${item.lastName}? User won't be removed but admin portal will no longer be accessible for this account.`,
                          onConfirm: () => onRevokeAccess(item)
                        })
                      }
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))
            ) : loading ? (
              <Loader colSpan="4" />
            ) : (
              <Placeholder placeholder="No People" colSpan="4" />
            )}
          </tbody>
        </table>
      </div>
    )
  },
  'user',
  {
    searchProperty: ['firstName', 'lastName', 'email']
  }
)
